// (function($) {

//   $.fn.sequencer = function(options, cb) {

//     var self = this,
//         paths = [],
//         load = 0,
//         sectionHeight,
//         windowHeight,
//         currentScroll,
//         percentageScroll,
//         index;

//     if(options.path.substr(-1) === "/") {
//       options.path = options.path.substr(0, options.path.length - 1)
//     }

//     for (var i = 0; i <= options.count; i++) {
//       paths.push("https://cdn.shopify.com/s/files/1/0082/6815/2912/files" + "/" + i + "." + options.ext + "?12480");
//     }

//     $("<div class='jquery-sequencer-preload'></div>").appendTo("body").css("display", "none");

//     $(paths).each(function() {
//       $("<img>").attr("src", this).on('load', function() {
//         $(this).appendTo("div.jquery-sequencer-preload");
//         load++;
//         if (load === paths.length) {
//           cb();
//         }
//       });
//     });

//     $(window).on('scroll', function() {
//   //  window.setInterval(function(){
//       sectionHeight = $(self).height();
//       windowHeight = $(this).height();
//       currentScroll = $(this).scrollTop();
//       percentageScroll = 100 * currentScroll / (sectionHeight - windowHeight);
//       index = Math.round(percentageScroll / 100 * options.count);
//       if(index < options.count) {
//         $("img.sequencer").attr("src", paths[index]);
//       }
//     });

//     return this;

//   };

// }(jQuery));
// $( document ).ready(function() {
  

$(function(){
  var hasBeenTrigged = false;
  $(window).scroll(function() {
      if ($(this).scrollTop() >= 300 && !hasBeenTrigged) { // if scroll is greater/equal then 100 and hasBeenTrigged is set to false.
      hasBeenTrigged = true;
      

      var i = 0;
      var flower = setInterval(function(){
        if(i == 50 ){
          i = 0;
        }
        else {
          if( i == 0){  $('#basic-waypoint').toggleClass('drop');}
          document.getElementById("image").src = "https://cdn.shopify.com/s/files/1/0082/6815/2912/files" + "/" + i + ".png?12480"; 
          i++;
      //     console.log(i);

        }
      },65);

      var j = 0;
      var text = ["Still thriving today, the Resurrection flower has the strength to endure the stress of complete dehydration for up to 31 months.", 
                  "After years of harsh drought, the magical Resurrection flower can spring back to a lush green state with a single drop of water.", 
                  "On the skin, the flower’s potent extract regenerates cells and protects against UV radiation for visibly rejuvenated, radiant skin."];
      var title = ["RESILIENT", "MAGICAL", "POTENT"];
      var flowertext = setInterval(function(){   
        if (j == 0) {
          document.getElementById("ftitle").textContent = title[0]; 
          document.getElementById("ftext").textContent = text[0]; 
          j++;

        } else if (j == 1) {
          document.getElementById("ftitle").textContent = title[1]; 
          document.getElementById("ftext").textContent = text[1]; 
          j++;

        } else if (j == 2) {
          document.getElementById("ftitle").textContent = title[2]; 
          document.getElementById("ftext").textContent = text[2]; 
          j=0;
        }
      },6000);
          
  }
    
 });
});
